import React from "react";
import styled from "styled-components";
import { Button } from "../../../Component/styledComponents/styledComponents";
import Nodejs from '../../../Component/Images/node.png';
import Javascript from "../../../Component/Images/js.png";
import HTML from "../../../Component/Images/html.png";
import Php from "../../../Component/Images/php.png";
import Mysql from "../../../Component/Images/mysql.png";
import Reactjs from "../../../Component/Images/react.png";
import { useNavigate } from "react-router-dom";

const Card = styled.div`
background-color: #282828;
border-radius:10px;
padding:60px 90px;
@media(max-width:1100px){
  padding:40px 30px 40px 60px;
}
`;
const Heading = styled.div`
font-size:34px;
color:#fff;
font-weight:bold;
margin-bottom:20px;
`;
const Text = styled.div`
color:#9b9b9b;
font-size:18px;
`;

const IconSection = styled.div`
margin-top:40px;
display:flex;
align-items: center;
width:100%;
justify-content: space-between;
`;
const IconWrapper = styled.div`
text-align:center;
`;
const Icon = styled.img`
@media(max-width:1100px){
  width:40px;
}
`;
const Subtitle = styled.div`
color:#9b9b9b ;
margin-top:5px;
`;
const WebDevelopment = () => {
   const navigation = useNavigate();
  return (
    <div>
       <Card>
        <Heading>
        Web Development 
        </Heading>
        <Text>
        As a progressive web development service provider, we have got everything to help create the best modern web experience. 
        </Text>
        <IconSection>
             <IconWrapper>
                <Icon src={Nodejs}/>
                <Subtitle>Node js</Subtitle>
             </IconWrapper>

             <IconWrapper>
                <Icon src={Javascript}/>
                <Subtitle>Javascript</Subtitle>
             </IconWrapper>

             {/* <IconWrapper>
                <Icon src={HTML}/>
                <Subtitle>HTML</Subtitle>
             </IconWrapper> */}
             <IconWrapper>
                <Icon src={Php}/>
                <Subtitle>Php</Subtitle>
             </IconWrapper>
             <IconWrapper>
                <Icon src={Mysql}/>
                <Subtitle>Mysql</Subtitle>
             </IconWrapper>
             <IconWrapper>
                <Icon src={Reactjs}/>
                <Subtitle>Reactjs</Subtitle>
             </IconWrapper>
        </IconSection>
        <Button
        border="#9b9b9b"
        color="#fff"
        top="12px"
        right="30px"
        left="30px"
        bottom="12px"
        radius="30px"
        mtop="30px"
        onClick={() => {navigation('/web_development')}}
        >
          EXPLORE
        </Button>
      </Card>
    </div>
  );
};

export default WebDevelopment;
